import React from "react";
import { Button } from "reactstrap";

type Props = Readonly<{
  disabled: boolean;
}>;

export const SubmitButton = ({ disabled }: Props) => {
  return (
    <Button color="primary" disabled={disabled} type="submit" title="Not implemented yet!">
      Submit
    </Button>
  );
};
SubmitButton.displayName = "SubmitButton";
